"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultConfig = {
  restEndpoint: 'https://uplight-marketplace-store.cdn.prismic.io/api/v2',
  accessToken: ''
};
var _default = defaultConfig;
exports["default"] = _default;